'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lsamples_Persons$package$Pet$1(name, age, House, size) {
  this.sU = null;
  this.sT = null;
  this.sS = null;
  this.sV = 0.0;
  this.sU = name;
  this.sT = age;
  this.sS = House;
  this.sV = size;
}
export { $c_Lsamples_Persons$package$Pet$1 as $c_Lsamples_Persons$package$Pet$1 };
$p = $c_Lsamples_Persons$package$Pet$1.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_Persons$package$Pet$1;
/** @constructor */
function $h_Lsamples_Persons$package$Pet$1() {
}
export { $h_Lsamples_Persons$package$Pet$1 as $h_Lsamples_Persons$package$Pet$1 };
$h_Lsamples_Persons$package$Pet$1.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.m = (function() {
  var acc = (-889275714);
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, 80127);
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, $j_java$002elang$002e$002dObject.$m_sr_Statics$().D(this.sU));
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, $j_java$002elang$002e$002dObject.$m_sr_Statics$().D(this.sT));
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, $j_java$002elang$002e$002dObject.$m_sr_Statics$().D(this.sS));
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, $j_java$002elang$002e$002dObject.$m_sr_Statics$().qW(this.sV));
  return $j_java$002elang$002e$002dObject.$m_sr_Statics$().an(acc, 4);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsamples_Persons$package$Pet$1)) {
    if ((this.sU === x$0.sU)) {
      var x = this.sT;
      var x$2 = x$0.sT;
      var $x_2 = ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.sS;
      var x$4 = x$0.sS;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      return (this.sV === x$0.sV);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.b = (function() {
  return $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().ah(this);
});
$p.n = (function() {
  return 4;
});
$p.o = (function() {
  return "Pet";
});
$p.g = (function(n) {
  switch (n) {
    case 0: {
      return this.sU;
      break;
    }
    case 1: {
      return this.sT;
      break;
    }
    case 2: {
      return this.sS;
      break;
    }
    case 3: {
      return this.sV;
      break;
    }
    default: {
      throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__I__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), n);
    }
  }
});
function $isArrayOf_Lsamples_Persons$package$Pet$1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.em)));
}
export { $isArrayOf_Lsamples_Persons$package$Pet$1 as $isArrayOf_Lsamples_Persons$package$Pet$1 };
var $d_Lsamples_Persons$package$Pet$1 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_Persons$package$Pet$1, "samples.Persons$package$Pet$1", ({
  em: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lsamples_Persons$package$Pet$1 as $d_Lsamples_Persons$package$Pet$1 };
